export function close_toast() {
  return new Promise((resolve) => {
    const toast = $('.maino-toast');
    
    if (!toast.length) {
      resolve();
      return;
    }
    
    const timer = toast.data('timer');
    if (timer) {
      clearInterval(timer);
      toast.removeData('timer');
    }
    
    toast.animate({
      right: '-500px',
      opacity: 0
    }, 400, function() {
      $(this).remove();
      resolve();
    });
  });
}
